import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import promise from 'redux-promise-middleware';
import reducers from '../reducers';

import '../config/ReactotronConfig';

const composer = process.env.NODE_ENV === 'development'
	? compose(
		applyMiddleware(...[]),
		// eslint-disable-next-line no-console
		console.tron.createEnhancer(),
	)
	: applyMiddleware(...[]);

const middlewares = [promise, thunk];

const createStoreWithMiddleWare = applyMiddleware(...middlewares)(createStore);

export default createStoreWithMiddleWare(reducers, composer);
